import { defineComponent as i, computed as l, createBlock as p, openBlock as u, unref as f } from "vue";
import { ScalarIcon as g } from "@scalar/components";
const I = /* @__PURE__ */ i({
  __name: "IntegrationLogo",
  props: {
    integration: {}
  },
  setup(n) {
    const a = n, r = [
      "adonisjs",
      "dotnet",
      "elysiajs",
      "express",
      "fastapi",
      "fastify",
      "go",
      "hono",
      "laravel",
      "litestar",
      "nestjs",
      "nextjs",
      "nitro",
      "nuxt",
      "platformatic",
      "react",
      "rust",
      "svelte"
    ], s = l(() => {
      var e;
      const o = "Openapi", t = (e = a.integration) == null ? void 0 : e.toLocaleLowerCase();
      if (!t)
        return o;
      const c = t.charAt(0).toUpperCase() + t.slice(1);
      return r.includes(t) ? c : o;
    });
    return (o, t) => (u(), p(f(g), {
      class: "h-full w-full rounded-lg",
      logo: s.value
    }, null, 8, ["logo"]));
  }
});
export {
  I as default
};
